import { FC } from "react";
import { LicenseTotals } from "../../data/interfaces/monthlyLicenseAudit";

interface Props {
  licenseTotals: LicenseTotals;
}

const TotalsTable: FC<Props> = ({ licenseTotals }) => {
  const startDate = new Date("4/28/22");
  const endDate = new Date();
  const toDate = new Date(licenseTotals.auditDate);

  const dateExist =
    toDate.getTime() >= startDate.getTime() &&
    toDate.getTime() <= endDate.getTime()
      ? true
      : false;

  return (
    <>
      <table className="table table-responsive table-sm">
        <thead>
          <tr>
            <th colSpan={3}>Licenses</th>
          </tr>
          <tr>
            <th className="text-center">Customers</th>
            <th className="text-center">Desktop</th>
            <th className="text-center">Mobile</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-center">{licenseTotals?.totalDealerships}</td>
            <td className="text-center">
              {licenseTotals?.totalDesktopLicenses}
            </td>
            <td className="text-center">
              {licenseTotals?.totalMobileLicenses}
            </td>
          </tr>
        </tbody>
      </table>
      <p className="text-center">
        {dateExist
          ? "License total as of " + toDate.toISOString().slice(0, 10) + "."
          : "License totals for " +
            toDate.toISOString().slice(0, 10) +
            " are not available. Current total is displayed instead."}
      </p>
    </>
  );
};

export default TotalsTable;
